import { forwardRef, HTMLProps, ReactNode } from 'react'
import { Squircle } from 'corner-smoothing'
interface SquircleAdapterProps extends HTMLProps<HTMLDivElement> {
  children: ReactNode
  cornerRadius: number
  bottomLeftCornerRadius?: number
  bottomRightCornerRadius?: number
  topLeftCornerRadius?: number
  topRightCornerRadius?: number
}

export const SquircleAdapter = forwardRef<HTMLDivElement, SquircleAdapterProps>(
  (
    {
      children,
      cornerRadius,
      bottomLeftCornerRadius,
      bottomRightCornerRadius,
      topLeftCornerRadius,
      topRightCornerRadius,
      ...rest
    },
    ref,
  ) => {
    const iosStyle = true

    if (iosStyle)
      return (
        <>
          {/* @ts-expect-error this sucks */}
          <Squircle
            ref={ref}
            cornerRadius={cornerRadius}
            bottomLeftCornerRadius={bottomLeftCornerRadius}
            bottomRightCornerRadius={bottomRightCornerRadius}
            topLeftCornerRadius={topLeftCornerRadius}
            topRightCornerRadius={topRightCornerRadius}
            {...rest}
          >
            {children}
          </Squircle>
        </>
      )

    return (
      <div style={{ borderRadius: 40 }} {...rest}>
        {children}
      </div>
    )
  },
)

SquircleAdapter.displayName = 'SquircleAdapter'
